(function() {
'use strict';

angular
    .module('core')
    .filter('roundedCurrency', roundedCurrency)
    .filter('roundUpToNearest', roundUpToNearest);

function roundedCurrency(currencyFilter, $locale, currencyService, decimalAdjust) {
    const formats = $locale.NUMBER_FORMATS;

    function separate(decimals, formats, result) {
        if (!decimals) {
            return result.lastIndexOf(formats.DECIMAL_SEP);
        }
        return result.lastIndexOf(formats.DECIMAL_SEP) + 3;
    }

    return function(amount, code = TRPCONFIG.Domain.CurrencyCode, type = 'ceil', decimals = false, exp = 0, spaced = false) {
        if (amount == null) {
            return undefined;
        }

        const sym = currencyService.getSymbol(code);

        if (isNaN(amount)) {
            if (amount.toString().indexOf(sym) >= 0) {
                const patt = new RegExp(`${sym}|,| `, 'g');
                const amountStr = amount.toString().replace(patt, '');
                amount = parseFloat(amountStr);
            } else {
                return undefined;
            }
        }

        if (type !== 'cut') {
            amount = decimalAdjust(type, amount, exp);
        }
        const res = sym ? currencyFilter(amount, sym) : currencyFilter(amount);
        const separated = separate(decimals, formats, res);
        const result = res.substring(0, separated) + res.substring(separated + 3);
        if (spaced) {
            const indexOfNumber = result.indexOf(result.match(/\d/));
            return `${result.substring(0, indexOfNumber)} ${result.substring(indexOfNumber)}`;
        }
        return result;
    };
}

// use to round a value up to nearest specified whole number
// used for ensuring price values are always rounded higher;
// defaults to use nearest 5 and 9

function roundUpToNearest(currencyFilter, currencyService) {
    return function(amount, code = TRPCONFIG.Domain.CurrencyCode, targets = [5, 9]) {
        if (angular.isNumber(targets)) {
            targets = [targets];
        }

        let value = Math.ceil(amount);

        const diff = Math.abs(value) % 10;
        //check if the amount already ends in the specified targets
        if (targets.indexOf(diff) === -1) {
            targets = targets.concat(targets.map(i => i + 10));
            targets.sort(function(a, b) { return a - b; });

            for (let i = 0; i < targets.length; i++) {
                if (diff < targets[i]) {
                    value += (targets[i] - diff);
                    break;
                }
            }
        }

        const sym = currencyService.getSymbol(code);
        const res = currencyFilter(value, sym, 0);

        return res;
    };
}


angular
    .module('core')
    .filter('customCurrency', customCurrency);

function customCurrency(currencyFilter, currencyService) {
    return (cost, code) => {
        if (cost == null || isNaN(cost)) {
            return undefined;
        }

        if (!code) {
            code = TRPCONFIG.Domain.CurrencyCode;
        }

        let symbol = currencyService.getCurrencies()[code];
        if (!symbol) {
            symbol = `${code} `;
        } else {
            symbol = symbol();
        }

        return currencyFilter(cost, symbol);
    };
}
})();
